import { loginRequest } from "#/authConfig";
import { getMsalInstance } from "#/msalClient";
import logger from "#/utils/logger";

const isAuthDisabled = import.meta.env.VITE_DISABLE_AUTH === 'true';

/**
 * Get the access token for API access
 */
export async function getAccessToken() {
    if (isAuthDisabled) {
        return 'testuser';
    }

    const account = getMsalInstance().getAllAccounts()[0];
    const request = {
        'account': account,
        ...loginRequest
    }

    try {
        const response = await getMsalInstance().acquireTokenSilent(request);
        return response.accessToken;
    } catch (error) {
        logger.warn("Silent token acquisition failed; caller must retry or trigger interactive sign-in.", error);
        throw error;
    }
}

/**
 * Logout
 */
export async function logout() {
    const instance = getMsalInstance();
    const logoutRequest = {
        account: getMsalInstance().getAllAccounts()[0]
      };
      instance.logoutRedirect(logoutRequest);
}

/**
 * Add authentication header to headers dictionary
 */
export async function addAuthHeader(
    headers: {[key: string]: string }) {
    if (isAuthDisabled) {
        headers['Authentication'] = 'Bearer testuser';
        return headers;
    }

    await Promise.resolve();
    headers['Authentication'] = 'Bearer ' + await getAccessToken();
    headers['X-App-Version'] = import.meta.env.PACKAGE_VERSION + "+" + import.meta.env.MODE;
    return headers;
}

/**
 * Get authentication token in Headers object
 */
export async function getAuthHeader()  {
    await Promise.resolve();
    let headers: { [key: string]: string } = {};
    return await addAuthHeader(headers);
}
